<template>
    <infinite-scroller-vertical @scrolledTillBottom="reachedBottom" :windowTarget="false">
        <v-list>
            <user-list-item v-for="follower in followers" :key="follower.id" :userDetail="follower"></user-list-item>
            <template v-if="followersLoading">
                <v-skeleton-loader type="list-item-avatar-two-line" v-for="n in 3" :key="'skeleton-follower-loader-' + n"></v-skeleton-loader>
            </template>
        </v-list>
    </infinite-scroller-vertical>
</template>
<script>
import {
    GET_FOLLOWER_LIST
} from "@/store/actions.type"
import {
    CLEAR_PROFILE_FOLLOWERS
} from "@/store/mutations.type"
import userListItem from "@/components/list-item/list-item-user.vue"

export default {
    components: {
        'user-list-item': userListItem
    },

    props: {
        userId: String
    },

    data: () => ({
        followersLoading: false,
    }),

    computed: {
        followers() {
            return this.$store.state.profile.profileFollowers
        }
    },

    created() {
        this.fetchFollowers()
    },

    methods: {
        fetchFollowers() {
            if (!this.followersLoading && !this.$store.state.profile.profileFollowersFetchCompleted) {
                this.followersLoading = true
                this.$store.dispatch(GET_FOLLOWER_LIST, {
                        userId: this.userId
                    })
                    .then(() => {
                        this.followersLoading = false
                    })
                    .catch(() => {
                        this.followersLoading = false
                    })
            }

        },

        reachedBottom(val) {
            if (val) {
                this.fetchFollowers()
            }
        }
    },

    destroyed() {
        this.$store.commit(CLEAR_PROFILE_FOLLOWERS)
    }
}
</script>